<div class="login-page">
  <div class="form">
    <div *ngIf="!hasChanges && !declineMode" class="flex flex-col">
      <span class="text-2xl text-biscay mb-4">Confirm Your Identity</span>
      <span class="mb-4"
        >Before accessing your documents, you must confirm your identity by
        entering your NPI below.</span
      >
    </div>
    <form [formGroup]="confirmIdentityForm" class="mb-5">
      <ng-container *ngIf="!hasChanges && !declineMode">
        <app-input
          [iconPrefix]="'fa-regular fa-user'"
          formControlName="npi"
          placeholder="Enter NPI"
        ></app-input>
        <mat-error *ngIf="invalidNPI">Invalid NPI</mat-error>
        <!-- <mat-error
          *ngIf="
            confirmIdentityForm?.get('npi')?.hasError('required') &&
            confirmIdentityForm?.get('npi')?.touched
          "
          >Required</mat-error
        > -->
      </ng-container>
      <ng-container *ngIf="hasChanges && !declineMode">
        <div class="flex flex-col">
          <div class="text-2xl text-biscay mb-4">
            <span class="text-danger mr-5"
              ><i class="fa-solid fa-triangle-exclamation"></i></span
            >Confirm Updates
          </div>
          <span class="mb-6">We noticed changes in your NPI information.</span>
          <span>User Name in our records: <strong>Arjo Neel</strong></span>
          <span class="mb-6"
            >Name on NPI record: <strong>Robert Tom</strong></span
          >
          <div class="mb-6">
            <mat-checkbox formControlName="terms"
              >I acknowledge the following changes are correct and authorize the
              system to update the following records.</mat-checkbox
            >
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="declineMode">
        <div>
          Please contact the NPI board to resolve. If you have questions please
          contact the facility administrator at facility admin email
        </div>
      </ng-container>
    </form>
    <thera-button
        *ngIf="!declineMode"
        class="pt-6"
        (click)="onContinue()"
        [config]="{
          text: 'Continue',
          variant: buttonVariant.PRIMARY
        }"
        [disabled]="!confirmIdentityForm.valid"
        >Continue</thera-button
      >
      <a
        *ngIf="!declineMode && hasChanges"
        class="block mt-3"
        (click)="onDecline()"
        >Decline</a
      >
  </div>
</div>
